import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  CREATE: 'CREATE_PROJECT_SUBMISSION',
  EDIT: 'EDIT_PROJECT_SUBMISSION',
  DELETE: 'DELETE_PROJECT_SUBMISSION',
  SUBMIT: 'SUBMIT_PROJECT_SUBMISSION',
  REVOKE: 'REVOKE_PROJECT_SUBMISSION',
  LIST: 'LIST_PROJECT_INSPECTION',
  GET: 'GET_PROJECT',
  APPROVE: 'APPROVE_PROJECT',
  REJECT: 'REJECT_PROJECT',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT_INSPECTION',
};

export const approveProject = projectId => {
  return {
    type: ACTION.APPROVE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_PROJECT_INSPECTION}${projectId}/approve/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const rejectProject = projectId => {
  return {
    type: ACTION.REJECT,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_PROJECT_INSPECTION}${projectId}/reject/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const createProjectSubmission = (projectId, name, description) => {
  const params = {
    project_id: projectId,
    name: name,
    description: description,
  };

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_INSPECTION,
      data: params,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editProjectSubmission = (id, name, description) => {
  const data = {
    name,
    description,
  };

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_PROJECT_INSPECTION}${id}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteProjectSubmission = (id) => ({
  type: ACTION.DELETE,
  payload: RestClient.request({
    method: 'delete',
    url: `${Constants.API_PROJECT_INSPECTION}${id}/`,
  })
    .then(() => ({ id }))
    .catch(err => Promise.reject(err.response.data.detail)),
});

export const submitProjectSubmission = (id) => ({
  type: ACTION.SUBMIT,
  payload: RestClient.request({
    method: 'post',
    url: `${Constants.API_PROJECT_INSPECTION}${id}/submit/`,
  }).catch(err => Promise.reject(err.response.data)),
});

export const revokeProjectSubmission = (id) => ({
  type: ACTION.REVOKE,
  payload: RestClient.request({
    method: 'post',
    url: `${Constants.API_PROJECT_INSPECTION}${id}/revoke/`,
  }).catch(err => Promise.reject(err.response.data)),
});

export const getProjectInspection = projectId => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_PROJECT_INSPECTION}${projectId}/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const searchProjectInspection = (pageSize, page, sorted, filtered, date, developer, status, projectId) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_INSPECTION,
    params: {
      project_id: projectId,
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sorted => sorted.desc ? `-${sorted.id}` : sorted.id ).join(',')
        : null,
      submission_date__date: date,
      user_id: developer,
      status: status,
    },
  });
};

export const listProjectInspectionByProject = (pageSize, page, sorted, filtered, projectId=null) => {
  return {
    type: ACTION.LIST,
    payload: searchProjectInspection(pageSize, page, sorted, filtered, null, null, null, projectId)
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const listProjectInspection = (pageSize, page, sorted, filtered, date, developer, status) => {
  return {
    type: ACTION.LIST,
    payload: searchProjectInspection(pageSize, page, sorted, filtered, date, developer, status, null)
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const clearErrorProjectInspection = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/project_inspection/project_inspection_actions.js